import { render, staticRenderFns } from "./HighScoreTable.vue?vue&type=template&id=656c229a&scoped=true&"
import script from "./HighScoreTable.vue?vue&type=script&lang=js&"
export * from "./HighScoreTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c229a",
  null
  
)

export default component.exports